import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../../../redux/slices/authSlice';
import VerificationSuccess from '../Verification/VerificationSuccess';
import VerificationFailed from '../Verification/VerificationFailed';
import { resendEmailVerification } from "../../../redux/slices/authSlice";

const VerifyAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { success, error, loading } = useSelector((state) => state.auth);

  const mail = searchParams.get('identifier');
  useEffect(() => {
    const token = searchParams.get('token');
  const identifier = searchParams.get('identifier');
    console.log(identifier, 'data')

    if (token && identifier) {
      dispatch(verifyEmail({ userIdentifier: identifier, code: token }));
    }
  }, [dispatch, searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(resendEmailVerification(mail));
    if (resendEmailVerification.fulfilled.match(result)) {
      navigate(`/verification-notifier/${mail}`);
    }
  };

  return (
    <div>
      {loading && <p> </p>}
      {success && <VerificationSuccess userMail={mail} />}
      {error && <VerificationFailed userMail={mail} handleResend={handleSubmit} loading={loading} />}
    </div>
  );
};

export default VerifyAccount;
